import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { TableCell, Avatar, Typography } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2C313D',
    color: theme.palette.common.white,
    border: 0,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: 0,
  },
}));

export const AvatarTableCell = (props) => {
  return (
    <StyledTableCell
      sx={{ display: 'flex', alignItems: 'center' }}
      key={props.index}
      scope={props.scope}
      align={props.align}
    >
      <Avatar sx={{ mr: 1.4, width: 35, height: 35 }} />
      <Typography sx={{ fontSize: '14px' }}>{props.value}</Typography>
    </StyledTableCell>
  );
};
